import {Box, Card, Container} from '@mui/material';
import React from 'react';
import {useQuery} from 'react-query';
import {useNavigate} from 'react-router-dom';
import DynamicList from 'src/components/DynamicList';
import Search from 'src/components/Search';
import {request} from 'src/utils/AdminApi';

export default function CustomersPage() {
	const navigate = useNavigate();
	const key = `all-customers`;

	const handleRowClick = (customer) => {
		navigate(`/customers/${customer.id}`);
	};

	return (
		<Container maxWidth="lg" sx={{mt: 4, mb: 4}}>
			<Card sx={{p: 2, mb: 3, fontSize: 16, fontWeight: 'bold'}}>
				<Box sx={{mb: 2}}>
					<Search placeholder="بحث عن عميل..." />
				</Box>
				<DynamicList
					api_route={key}
					cols={[
						// 'id',
						{label: 'الإسم', key: 'name'},
						{label: 'الهاتف', key: 'phone'},
						{label: 'البريد الإلكتروني', key: 'email'},
					]}
					usePagination
					// onRowClick={handleRowClick}
				/>
			</Card>
		</Container>
	);
}
